<sw-page class="riccardo-offer-list">
    <template #smart-bar-header>
        <h2>{{ $t('riccardo-offer.list.title') }} <span v-if="!isLoading">({{ total }})</span></h2>
    </template>

    <template #smart-bar-actions>
        <sw-button variant="primary" :router-link="{ name: 'riccardo.offer.create' }">
            {{ $t('riccardo-offer.list.buttonCreate') }}
        </sw-button>
    </template>

    <template #content>
        <sw-entity-listing
            v-if="offers"
            :items="offers"
            :repository="offerRepository"
            :columns="columns"
            :is-loading="isLoading"
            :show-selection="false"
            detail-route="riccardo.offer.detail"
            @update-records="getList"
        >
            <template #column-active="{ item }">
                <sw-icon :name="item.active ? 'regular-checkmark-xs' : 'regular-times-s'" :color="item.active ? '#37d046' : '#de294c'" small />
            </template>
            <template #column-audience="{ item }">{{ $t('riccardo-offer.detail.audience_' + item.audience) }}</template>
            <template #column-durationHours="{ item }">{{ formatValidity(item) }}</template>
        </sw-entity-listing>

        <sw-empty-state v-else-if="!isLoading" :title="$t('riccardo-offer.list.empty')" icon="regular-megaphone" />
    </template>
</sw-page>
